import React from 'react';

import AdvancedCombat from './advanced-combat';
import YourStory      from './your-story';
import FooterImage    from '../footer-image';
import PageNav        from '../page-nav';

export default function Page3() {
    return (
        <>
            <YourStory />
            <AdvancedCombat />
            <PageNav isBottom={true} />
            <FooterImage />
        </>
    );
}
